import {
	ListItemButton,
	ListItemIcon,
	ListItemText,
	Menu,
	MenuItem,
	Typography
} from '@mui/material';
import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from 'react-router-dom';

function NavItemMenu({ navText, sx, variant, menuItems, Icon }) {
	const navigate = useNavigate();

	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		// This is querying for the nav item text.
		const listItemText = event.currentTarget.children[1];

		setAnchorEl(listItemText);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	return (
		<>
			<ListItemButton onClick={handleClick}>
				<ListItemIcon sx={{ paddingLeft: 2 }}>
					<Icon sx={{ ...sx, width: '24px' }} />
				</ListItemIcon>
				<ListItemText>
					<Typography variant={variant} sx={sx}>
						{navText}
					</Typography>
				</ListItemText>
			</ListItemButton>
			<Menu
				id="basic-menu"
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				MenuListProps={{
					'aria-labelledby': 'basic-button'
				}}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'center'
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'right'
				}}
			>
				{menuItems.map(({ route, navText }) => (
					<MenuItem key={uuidv4()} onClick={() => navigate(route)}>
						{navText}
					</MenuItem>
				))}
			</Menu>
		</>
	);
}

export default NavItemMenu;
